module.exports = __webpack_public_path__ + "static/media/image2.6af06f5f.jpg";